<ng-template #addressModalForm let-modal>

  <app-modal-comp-header
    [title]="formTitle"
    (cancelButtonOnClick)="addressFormCancel()"
  ></app-modal-comp-header>
  
  <form
    autocomplete="off"
    [attr.autocomplete]="autofill ? 'on' : 'off'"
    class="tablelist-form"
    [formGroup]="addressForm"
    (ngSubmit)="addressFormSubmit()"
  >
    <div class="modal-body">
                                     
      <div class="row">
        <div class="col-12">
          <div class="border border-success rounded">
            <label class="form-label"></label>

            @if (addressSearch) {
              <div class="row">
                <div class="col-4">
                  <div class="mb-2 px-2">
                    <label for="postcodeLookup-field" class="form-label">Find Address</label>
                  </div>
                </div>
                <div class="col-8">
                  <div class="mb-2 px-2">
                    <div class="input-group">
                      <input
                        [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                        [attr.name]="autofill ? 'postcodeLookup-field' : 'postcodeLookup-field-secret'"
                        class="form-control"
                        data-lpignore="true"
                        formControlName="postcodeLookup"
                        id="postcodeLookup-field"
                        placeholder="Postcode Lookup"
                        type="text"
                      />
                      <button class="btn btn-success" type="button" (click)="postcodeLookup(true)">Search</button>
                    </div>
                  </div>
                </div>
              </div>
            }
            
            @if(foundAddresses) {
            <div class="row">
              <div class="col-4">
                <div class="mb-2 px-2">
                  <label for="selectAddress-field" class="form-label">Select Address</label>
                </div>
              </div>
              <div class="col-8">
                <div class="mb-3 px-2">
                  <select
                    class="form-select"
                    formControlName="selectAddress"
                    id="selectAddress-field"
                    name="selectAddress-field"
                    [ngClass]="{
                      'address-empty': !formOfAddress['selectAddress'].value,
                      'address-filled': formOfAddress['selectAddress'].value
                    }"
                    (change)="selectAddressDropDownChange($event)"
                  >
                    @for (object of getDropdownDataObjectArrayForSelectAddress(); track object.id) {
                      <option [ngValue]="object.id">{{
                                                    (
                                                     (object.line1=="" ? "" : object.line1) + "," +
                                                     (object.line2=="" ? "" : object.line2) + "," +
                                                     (object.line3=="" ? "" : object.line3) + "," +
                                                     (object.townOrCity=="" ? "" : object.townOrCity) + "," +
                                                     (object.county=="" ? "" : object.county) + "," +
                                                     (object.postCode=="" ? "" : object.postCode)
                                                    ).replace(",,",",").replace(",,",",").replace(",,",",").replace(",,",",")
                                                    }}
                      </option>
                    }
                  </select>
                </div>
              </div>
            </div>
            }

            <div class="row">
              <div class="col-4">
                <div class="mb-2 px-2">
                  <label for="line1-field" class="form-label">First Line</label>
                </div>
              </div>
              <div class="col-8">
                <div class="mb-2 px-2">
                  <input
                    [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                    [attr.name]="autofill ? 'line1-field' : 'line1-field-secret'"
                    class="form-control"
                    data-lpignore="true"
                    formControlName="line1"
                    id="line1-field"
                    [ngClass]="{ 'is-invalid': formSubmitted && formOfAddress['line1'].errors }"
                    placeholder=""
                    type="text"
                  />
                  @if(formOfAddress['line1'].hasError('maxlength')) {
                    <div class="invalid-feedback">Maximum length of {{line1MaxLength}} characters has been exceeded</div>
                  } @else {
                    <div class="invalid-feedback">A value is required</div>
                  }
                </div>
              </div>
            </div>
                                           
            <div class="row">
              <div class="col-4">
                <div class="mb-2 px-2">
                  <label for="line2-field" class="form-label"></label>
                </div>
              </div>
              <div class="col-8">
                <div class="mb-2 px-2">
                  <input
                    [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                    [attr.name]="autofill ? 'line2-field' : 'line2-field-secret'"
                    class="form-control"
                    data-lpignore="true"
                    formControlName="line2"
                    id="line2-field"
                    [ngClass]="{ 'is-invalid': formSubmitted && formOfAddress['line2'].errors }"
                    placeholder=""
                    type="text"
                  />
                  @if(formOfAddress['line2'].hasError('maxlength')) {
                    <div class="invalid-feedback">Maximum length of {{line2MaxLength}} characters has been exceeded</div>
                  } @else {
                    <div class="invalid-feedback">A value is required</div>
                  }
                </div>
              </div>
            </div>
                                           
            <div class="row">
              <div class="col-4">
                <div class="mb-2 px-2">
                  <label for="line3-field" class="form-label"></label>
                </div>
              </div>
              <div class="col-8">
                <div class="mb-2 px-2">
                  <input
                    [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                    [attr.name]="autofill ? 'line3-field' : 'line3-field-secret'"
                    class="form-control"
                    data-lpignore="true"
                    formControlName="line3"
                    id="line3-field"
                    [ngClass]="{ 'is-invalid': formSubmitted && formOfAddress['line3'].errors }"
                    placeholder=""
                    type="text"
                  />
                  @if(formOfAddress['line3'].hasError('maxlength')) {
                    <div class="invalid-feedback">Maximum length of {{line3MaxLength}} characters has been exceeded</div>
                  } @else {
                    <div class="invalid-feedback">A value is required</div>
                  }
                </div>
              </div>
            </div>
                                           
            <div class="row">
              <div class="col-4">
                <div class="mb-2 px-2">
                  <label for="townOrCity-field" class="form-label">Town/City</label>
                </div>
              </div>
              <div class="col-8">
                <div class="mb-2 px-2">
                  <input
                    [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                    [attr.name]="autofill ? 'townOrCity-field' : 'townOrCity-field-secret'"
                    class="form-control"
                    data-lpignore="true"
                    formControlName="townOrCity"
                    id="townOrCity-field"
                    [ngClass]="{ 'is-invalid': formSubmitted && formOfAddress['townOrCity'].errors }"
                    placeholder=""
                    type="text"
                  />
                  @if(formOfAddress['townOrCity'].hasError('maxlength')) {
                    <div class="invalid-feedback">Maximum length of {{townOrCityMaxLength}} characters has been exceeded</div>
                  } @else {
                    <div class="invalid-feedback">A value is required</div>
                  }
                </div>
              </div>
            </div>
                                           
            <div class="row">
              <div class="col-4">
                <div class="mb-2 px-2">
                  <label for="county-field" class="form-label">County</label>
                </div>
              </div>
              <div class="col-8">
                <div class="mb-2 px-2">
                  <input
                    [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                    [attr.name]="autofill ? 'county-field' : 'county-field-secret'"
                    class="form-control"
                    data-lpignore="true"
                    formControlName="county"
                    id="county-field"
                    [ngClass]="{ 'is-invalid': formSubmitted && formOfAddress['county'].errors }"
                    placeholder=""
                    type="text"
                  />
                  @if(formOfAddress['county'].hasError('maxlength')) {
                    <div class="invalid-feedback">Maximum length of {{countyMaxLength}} characters has been exceeded</div>
                  } @else {
                    <div class="invalid-feedback">A value is required</div>
                  }
                </div>
              </div>
            </div>
                                           
            <div class="row">
              <div class="col-4">
                <div class="mb-2 px-2">
                  <label for="postCode-field" class="form-label">Postcode</label>
                </div>
              </div>
              <div class="col-8">
                <div class="mb-2 px-2">
                  <input
                    [attr.autocomplete]="autofill ? 'on' : 'no-fill'"
                    [attr.name]="autofill ? 'postCode-field' : 'postCode-field-secret'"
                    class="form-control"
                    data-lpignore="true"
                    formControlName="postCode"
                    id="postCode-field"
                    [ngClass]="{ 'is-invalid': formSubmitted && formOfAddress['postCode'].errors }"
                    placeholder=""
                    type="text"
                  />
                  @if(formOfAddress['postCode'].hasError('maxlength')) {
                    <div class="invalid-feedback">Maximum length of {{postCodeMaxLength}} characters has been exceeded</div>
                  } @else {
                    <div class="invalid-feedback">A value is required</div>
                  }
                </div>
              </div>
            </div>
                                           
            <div class="row">
              <div class="col-4">
                <div class="mb-2 px-2">
                  <label for="countryId-field" class="form-label">Country</label>
                </div>
              </div>
              <div class="col-8">
                <div class="mb-3 px-2">
                  <select
                    class="form-select"
                    formControlName="countryId"
                    id="countryId-field"
                    name="countryId-field"
                    [ngClass]="{ 'is-invalid': formSubmitted && formOfAddress['countryId'].errors }"
                  >
                    <option selected></option>
                    @for (object of getDropdownDataObjectArray("countryId"); track object.id) {
                      <option [ngValue]="object.id">{{object.description}}</option>    
                    }
                  </select>
                  <div class="invalid-feedback">A value is required</div>
                </div>
              </div>
            </div>
                                         
          </div>
        </div>
      </div>

    </div>
    <div class="modal-footer">
      <div class="hstack gap-2 justify-content-end">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="addressFormCancel()">Close</button>
        <button type="submit" class="btn btn-success" id="add-btn">Submit</button>
      </div>
    </div>
  </form>
</ng-template>

<app-warning-modal-form #warningModalForm
></app-warning-modal-form>
